export default function ColorBox({dim=20,color}){

  return (
    <div style={{
      position:'relative',
      width:20,
      height:20,
      borderRadius:2,
      background:(color||"white"),
      border:'1px solid #aaa',
    }}/>
  )


}
